import { defineComponent as _defineComponent } from 'vue'
import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, createStaticVNode as _createStaticVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "setup-complete-step" }
const _hoisted_2 = { class: "success-icon" }

import { ref } from "vue";

type SetupCompleteStepExpose = {
  getValues?: () => Record<string, any>;
};

// This step doesn't need any values since it's just a completion screen

export default /*@__PURE__*/_defineComponent({
  __name: 'SetupCompleteStep',
  setup(__props, { expose: __expose }) {

const values = ref<Record<string, any>>({});

function getValues() {
  return values.value;
}

__expose<SetupCompleteStepExpose>({
  getValues,
});

return (_ctx: any,_cache: any) => {
  const _component_v_icon = _resolveComponent("v-icon")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_v_icon, {
        size: "64",
        color: "success"
      }, {
        default: _withCtx(() => [...(_cache[0] || (_cache[0] = [
          _createTextVNode("mdi-check-circle", -1)
        ]))]),
        _: 1
      })
    ]),
    _cache[1] || (_cache[1] = _createStaticVNode("<h2 class=\"success-title\" data-v-571f4d91>Setup Complete!</h2><p class=\"success-message\" data-v-571f4d91> Your vendor profile has been successfully set up. You can now start managing your pest control business. </p><div class=\"next-steps\" data-v-571f4d91><h3 class=\"next-steps-title\" data-v-571f4d91>What&#39;s Next?</h3><ul class=\"next-steps-list\" data-v-571f4d91><li data-v-571f4d91>Manage your services and pricing</li><li data-v-571f4d91>Create and send quotations</li><li data-v-571f4d91>Track customer inquiries</li><li data-v-571f4d91>View your dashboard analytics</li></ul></div>", 3))
  ]))
}
}

})